export { default } from "./Search";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/pages/Search/index.js